import _sumBy from "lodash/sumBy";
import _get from "lodash/get";

export function unreadMessagesCount(messages) {
  return _sumBy(messages, (channel) => channel.has_been_read ? 0 : _get(channel, "messages.length", 0)
  );
};
